import {Skeleton} from '@dropbox/dig-components/skeleton';
import {Text} from '@dropbox/dig-components/typography';
import {atoms, Box, Split, Stack} from '@dropbox/dig-foundations';
import {Tile} from 'views/home/dashboard/Tile';

import styles from './TeamCalendar.module.css';

const WEEKDAYS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
// Always 6 weeks, mirroring the real grid so the skeleton fills the same space.
const GRID_DAYS = 42;

/**
 * Loading state for the Team calendar tile in calendar view — mirrors the month
 * grid (header label + weekday row + 6×7 cells) so the skeleton lines up with
 * the real calendar instead of the list-style avatar+name rows.
 */
export const TeamCalendarSkeleton = ({monthLabel}: {monthLabel?: string}) => (
  <Tile
    tileId="calendar"
    label={monthLabel}
    accessory={
      <Split gap="4">
        <Skeleton.Box width={24} height={24} withBorderRadius="small" />
        <Skeleton.Box width={24} height={24} withBorderRadius="small" />
        <Skeleton.Box width={24} height={24} withBorderRadius="small" />
      </Split>
    }
  >
    <Stack gap="8" display="flex" height="100%">
      <Box
        style={{
          marginInline: -8,
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box className={styles.weekRow} aria-hidden>
          {WEEKDAYS.map((weekday, index) => (
            <Text
              key={index}
              size="xsmall"
              color="faint"
              tagName="span"
              isBold
              className={[styles.weekday, atoms({textAlign: 'center'})].join(' ')}
            >
              {weekday}
            </Text>
          ))}
        </Box>
        <Box className={styles.grid} style={{flex: 1, minHeight: 0}} aria-hidden>
          {Array.from({length: GRID_DAYS}).map((_, index) => (
            <Box
              key={index}
              className={styles.day}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Skeleton.Box width={16} height={16} withBorderRadius="small" />
            </Box>
          ))}
        </Box>
      </Box>
    </Stack>
  </Tile>
);
